import * as React from 'react';
// import classnames from 'classnames';
import './index.scss';

export default function Image(props) {
  const { src, boxWidth, boxHeight } = props;
  const [style, setStyle] = React.useState({
    boxWidth:24,
    boxHeight:24
  });

  React.useEffect(() => {
    // 判断图片大小
    const img = new window.Image();
    img.onload = function () {
      const result = {};
      if (img.width > img.height) {
        result.width = boxWidth;
      } else {
        result.height = boxHeight;
      }
      

      setStyle(result);
    }
    img.src = src;
  }, [props.src]);

  return (
    <img alt="" src={src} style={style} />
  )
}